import { boot } from 'quasar/wrappers'

export default boot(({ app }) => {
  app.config.globalProperties.$gb = {
    filter (val, update) {
      try {
        if (val === '') {
          update(() => {
            this.filterAccounts = this.accounts
          })
          return
        }
        update(() => {
          this.filterAccounts = this.accounts.filter(v => {
            return v.label.toLowerCase().includes(val.toLowerCase())
          })
        })
      } catch (e) {
        throw new Error(e)
      }
    }
  }

  app.config.globalProperties.$setBotBreadcrumbs = function (botData, sectionKey) {
    const loc = this.$store.state.localization[this.$store.state.localization.language].pages.settings.chatbot
    const botName = botData.t || ''
    const isTruncated = botName.length > 22
    const truncatedName = isTruncated ? botName.slice(0, 22) + '…' : botName

    if (sectionKey) {
      this.$store.commit('main/setBreadcrumbs', {
        title: loc[sectionKey] + ' | ' + botName,
        paths: [
          { label: loc.chatbots, route: '/bots' },
          { label: loc.preferences + ' | ' + truncatedName, route: '/settings/chatbot/' + botData._id, tooltip: isTruncated ? botName : undefined },
          { label: loc[sectionKey] }
        ]
      })
    } else {
      this.$store.commit('main/setBreadcrumbs', {
        title: loc.preferences + ' | ' + botName,
        paths: [
          { label: loc.chatbots, route: '/bots' },
          { label: loc.preferences + ' | ' + truncatedName, tooltip: isTruncated ? botName : undefined }
        ]
      })
    }
  }
})
